import React, { FC } from 'react';
import Form from 'react-bootstrap/Form';
import TooltipWrapper from 'components/TooltipWrapper';
import { FaRegQuestionCircle } from 'react-icons/fa';
import styled from 'styled-components';

interface IFormLabelProps {
  name?: string;
  label: string;
  isRequired?: boolean;
  isHorizontal?: boolean;
  tooltip?: string;
  labelGrid?: number;
  tooltipPosition?: 'left' | 'right';
}

/*
 * Abstracted label component, displaying form control labels.
 * It serves different layout based on props.
 */
const FormLabel: FC<IFormLabelProps> = ({
  name,
  label,
  isRequired,
  isHorizontal,
  tooltip,
  labelGrid,
  tooltipPosition = 'left',
}) => {
  return (
    <StyledFormLabel
      column
      lg={isHorizontal ? labelGrid || 2 : 12}
      className={isHorizontal ? 'text-right' : 'text-left'}
    >
      {tooltip && name && tooltipPosition === 'left' && (
        <TooltipWrapper
          id={`${name}-tooltip`}
          overlay={tooltip}
        >
          <FaRegQuestionCircle
            size={18}
            style={{ marginRight: 6 }}
          />
        </TooltipWrapper>
      )}

      {isHorizontal && isRequired && '* '}
      {label}
      {!isHorizontal && isRequired && ' *'}

      {tooltip && name && tooltipPosition === 'right' && (
        <TooltipWrapper
          id={`${name}-tooltip`}
          overlay={tooltip}
        >
          <FaRegQuestionCircle
            size={18}
            style={{ marginLeft: 6 }}
          />
        </TooltipWrapper>
      )}
    </StyledFormLabel>
  );
};

const StyledFormLabel = styled(Form.Label)`
  @media ${props => props.theme.breakpoints?.lg} {
    text-align: left !important;
  }
`;

export default FormLabel;
